import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'pps-signin-redirect-callback',
  template: "<div></div>",
  styles: [
  ],
})
export class SigninRedirectCallbackComponent implements OnInit {

  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.authService.completeLogin()
      .then(userContext => {
        console.log("User login completed: " + userContext);
        this.router.navigate(["/home"], { replaceUrl: true});
      })
  }
}
